module.exports = __webpack_public_path__ + "static/media/logo_anvr_wit.5accf0ab.svg";